import { OnInit, OnChanges, EventEmitter } from '@angular/core';
import { FormGroup, ControlValueAccessor } from '@angular/forms';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
var INDRARangeInputComponent = /** @class */ (function () {
    function INDRARangeInputComponent(currencyService) {
        this.currencyService = currencyService;
        this.availableSteps = [];
        this.maxSelectableStep = 18000;
        this.minLimit = 0;
        this.parentForm = null;
        this.formControlName = null;
        this.promoValue = null;
        this.hasPromo = false;
        this.initAnimate = true;
        /* from post sprint 9 merge
        @Input() discountUnit: string = 'M';
    
        @Input() ticksArray = [];
        @Input() showTicks = true;
        */
        this.disabled = false;
        this.manualRefresh = new EventEmitter();
        this.userChangeEnd = new EventEmitter();
        // The internal data model
        this.innerValue = 0;
        this.onChangeCallback = function (_) { };
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
    }
    INDRARangeInputComponent.prototype.ngOnInit = function () {
        // this.INDRA_initializeSlider();
    };
    INDRARangeInputComponent.prototype.ngOnChanges = function () {
        this.INDRA_initializeSlider();
        this.manualRefresh.emit();
    };
    INDRARangeInputComponent.prototype.INDRA_initializeSlider = function () {
        var _this = this;
        this.options = {
            disabled: this.disabled,
            ariaLabel: this.INDRA_getSliderAriaLabel(),
            stepsArray: this.availableSteps,
            showTicks: true,
            showSelectionBar: true,
            autoHideLimitLabels: false,
            hideLimitLabels: true,
            minLimit: this.minLimit,
            translate: function (value) {
                return _this.currencyService.INDRA_formatMiles(value) + " M" + '<div>' + _this.INDRA_printDiscount(value) + '</div>';
            },
            ticksTooltip: function (index) {
                return '<span class="bold">' + (_this.currencyService.INDRA_formatMiles(_this.availableSteps[index].value) + " M") + '</span><br>' + _this.INDRA_printDiscount(_this.availableSteps[index].value);
            }
        };
        var maxLimitIndex = this.availableSteps.findIndex(function (step) { return step.maxLimit; });
        if (maxLimitIndex > -1) {
            this.options.maxLimit = maxLimitIndex;
        }
    };
    /* note: from post-sprint 8 merge
    TAP_initializeSlider() {
        this.options = {
            ariaLabel: this.TAP_getSliderAriaLabel(),
            showSelectionBar: true,
            autoHideLimitLabels: false,
            hideLimitLabels: true,
        };
        
        if (this.availableSteps.length > 0) {
            this.options.showTicks = true;
            this.options.stepsArray = this.availableSteps;
            this.options.minLimit = this.minLimit;
            this.options.translate = (value: number): string => {
                return `${value.toLocaleString('pt')} ${this.discountUnit}` + '<div>' + this.TAP_printDiscount(value) + '</div>';
            };
            this.options.ticksTooltip = (index: number): string => {
                return '<span class="bold">' + `${this.availableSteps[index].value.toLocaleString('pt')} ${this.discountUnit}` + '</span><br>' + this.TAP_printDiscount(this.availableSteps[index].value);
            };
        } else {
            this.options.floor = this.min;
            this.options.ceil = this.max;
            this.options.step = 0.01;
            this.options.translate = (value: number): string => {
                return `${value.toLocaleString('pt')} ${this.discountUnit}` + '<div>' + this.TAP_printPromoDiscount(value) + '</div>';
            };

        }

        if (this.ticksArray.length > 0)
            this.options.ticksArray = this.ticksArray;
    }
    
    TAP_printPromoDiscount(value) {
        return '-' + (value + 8).toLocaleString('pt', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    */
    INDRARangeInputComponent.prototype.INDRA_printDiscount = function (value) {
        var discount = '';
        var STEP = this.INDRA_getStep(value);
        if (STEP !== undefined) {
            discount = '-' + this.currencyService.INDRA_formatCash(STEP.discount) + ' ' + this.currency;
            if (this.hasPromo && value === this.promoValue) {
                discount += '<br><div class="is-promo"></div>';
            }
        }
        return discount;
    };
    INDRARangeInputComponent.prototype.INDRA_getStep = function (value) {
        return this.availableSteps.find(function (step) {
            return step.value === value;
        });
    };
    INDRARangeInputComponent.prototype.INDRA_getSliderAriaLabel = function () {
        return 'Use left and right keyboard keys to select amount of miles';
        // return 'Use left and right keyboard keys to select amount of ' + (this.discountUnit === 'M' ? 'miles' : 'promos');
    };
    INDRARangeInputComponent.prototype.INDRA_onChange = function () {
        this.userChangeEnd.emit();
    };
    Object.defineProperty(INDRARangeInputComponent.prototype, "value", {
        // get accessor
        get: function () {
            return this.innerValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            if (v !== this.innerValue) {
                this.innerValue = this.min;
                this.onChangeCallback(v);
            }
            else {
                this.innerValue = this.min;
            }
        },
        enumerable: true,
        configurable: true
    });
    // Set touched on blur
    INDRARangeInputComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    // From ControlValueAccessor interface
    INDRARangeInputComponent.prototype.writeValue = function (value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    };
    // From ControlValueAccessor interface
    INDRARangeInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    // From ControlValueAccessor interface
    INDRARangeInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    return INDRARangeInputComponent;
}());
export { INDRARangeInputComponent };
